import { Mapper } from "../../../../base/utils/mapper";
import { TypeFinalityModel } from "../../../../domain/models/consult/type-finality.model";
import { TypeFinalityEntity } from "../entities/type-finality.entity";


export class TypeFinalityImplementationRepositoryMapper extends Mapper<TypeFinalityEntity, TypeFinalityModel> {
    mapFrom(param: TypeFinalityEntity): TypeFinalityModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeFinalityModel): TypeFinalityEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}